module.exports = __webpack_public_path__ + "static/img/sharetips.c604f83.1780911843607.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sharetips.png
// module id = kg+M
// module chunks = 75